var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page" },
    [
      _c(
        "el-form",
        {
          ref: "searchForm",
          staticClass: "query-form",
          attrs: { size: "small", inline: true, model: _vm.searchForm },
          nativeOn: {
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.refreshList()
            },
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { prop: "tuser.id" } },
            [
              _c("user-select", {
                attrs: {
                  limit: 1,
                  size: "small",
                  placeholder: "请选择用户",
                  value: _vm.searchForm.tuser.id,
                },
                on: {
                  getValue: function (value) {
                    _vm.searchForm.tuser.id = value
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { prop: "name" } },
            [
              _c("el-input", {
                attrs: { size: "small", placeholder: "名称", clearable: "" },
                model: {
                  value: _vm.searchForm.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchForm, "name", $$v)
                  },
                  expression: "searchForm.name",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { prop: "sex" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.searchForm.sex,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchForm, "sex", $$v)
                    },
                    expression: "searchForm.sex",
                  },
                },
                _vm._l(_vm.$dictUtils.getDictList("sex"), function (item) {
                  return _c(
                    "el-radio",
                    { key: item.value, attrs: { label: item.value } },
                    [_vm._v(_vm._s(item.label))]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { prop: "inDate" } },
            [
              _c("el-date-picker", {
                attrs: {
                  type: "daterange",
                  size: "small",
                  align: "right",
                  "value-format": "yyyy-MM-dd hh:mm:ss",
                  "unlink-panels": "",
                  "range-separator": "至",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "结束日期",
                },
                model: {
                  value: _vm.searchForm.inDate,
                  callback: function ($$v) {
                    _vm.$set(_vm.searchForm, "inDate", $$v)
                  },
                  expression: "searchForm.inDate",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    icon: "el-icon-search",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.refreshList()
                    },
                  },
                },
                [_vm._v("查询")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", icon: "el-icon-refresh-right" },
                  on: {
                    click: function ($event) {
                      return _vm.resetSearch()
                    },
                  },
                },
                [_vm._v("重置")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "bg-white top" },
        [
          _c("vxe-toolbar", {
            attrs: {
              refresh: { query: _vm.refreshList },
              import: "",
              export: "",
              print: "",
              custom: "",
            },
            scopedSlots: _vm._u([
              {
                key: "buttons",
                fn: function () {
                  return [
                    _vm.hasPermission("test:onetomany:testDataMainForm:add")
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              size: "small",
                              icon: "el-icon-plus",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.add()
                              },
                            },
                          },
                          [_vm._v("新建")]
                        )
                      : _vm._e(),
                    _vm.hasPermission("test:onetomany:testDataMainForm:edit")
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "warning",
                              size: "small",
                              icon: "el-icon-edit-outline",
                              disabled:
                                _vm.$refs.testDataMainFormTable &&
                                _vm.$refs.testDataMainFormTable.getCheckboxRecords()
                                  .length !== 1,
                              plain: "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.edit()
                              },
                            },
                          },
                          [_vm._v("修改")]
                        )
                      : _vm._e(),
                    _vm.hasPermission("test:onetomany:testDataMainForm:del")
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "danger",
                              size: "small",
                              icon: "el-icon-delete",
                              disabled:
                                _vm.$refs.testDataMainFormTable &&
                                _vm.$refs.testDataMainFormTable.getCheckboxRecords()
                                  .length === 0,
                              plain: "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.del()
                              },
                            },
                          },
                          [_vm._v("删除")]
                        )
                      : _vm._e(),
                  ]
                },
                proxy: true,
              },
              {
                key: "tools",
                fn: function () {
                  return [
                    _vm.hasPermission("test:onetomany:testDataMainForm:import")
                      ? _c("vxe-button", {
                          staticClass: "el-icon-document m-r-12",
                          attrs: {
                            type: "default",
                            title: "下载导入模板",
                            circle: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.downloadTpl()
                            },
                          },
                        })
                      : _vm._e(),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
          _c(
            "div",
            { staticStyle: { height: "calc(100% - 80px)" } },
            [
              _c(
                "vxe-table",
                {
                  ref: "testDataMainFormTable",
                  attrs: {
                    border: "inner",
                    "auto-resize": "",
                    resizable: "",
                    height: "auto",
                    loading: _vm.loading,
                    size: "small",
                    "show-header-overflow": "",
                    "show-overflow": "",
                    "highlight-hover-row": "",
                    "menu-config": {},
                    "print-config": {},
                    "import-config": {
                      importMethod: _vm.importMethod,
                      types: ["csv", "xls", "xlsx"],
                      remote: true,
                    },
                    "export-config": {
                      remote: true,
                      filename:
                        "票务代理数据" +
                        _vm.moment(new Date()).format("YYYY-MM-DD"),
                      sheetName: "票务代理数据",
                      exportMethod: _vm.exportMethod,
                      types: ["xlsx"],
                      modes: ["current", "selected", "all"],
                    },
                    "sort-config": { remote: true },
                    "expand-config": {
                      accordion: true,
                      lazy: true,
                      loadMethod: _vm.detail,
                    },
                    data: _vm.dataList,
                    "checkbox-config": {},
                  },
                  on: { "sort-change": _vm.sortChangeHandle },
                },
                [
                  _c("vxe-column", { attrs: { type: "seq", width: "40" } }),
                  _c("vxe-column", {
                    attrs: { type: "checkbox", width: "40px" },
                  }),
                  _c("vxe-column", {
                    attrs: { type: "expand", width: "80" },
                    scopedSlots: _vm._u([
                      {
                        key: "content",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c(
                              "el-tabs",
                              [
                                _c(
                                  "el-tab-pane",
                                  { attrs: { label: "汽车票" } },
                                  [
                                    _c(
                                      "el-table",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          size: "small",
                                          data: row.testDataChild23DTOList,
                                        },
                                      },
                                      [
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "startArea.name",
                                            label: "出发地",
                                          },
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "endArea.name",
                                            label: "目的地",
                                          },
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "startTime",
                                            "show-overflow-tooltip": "",
                                            label: "出发时间",
                                          },
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "endTime",
                                            "show-overflow-tooltip": "",
                                            label: "到达时间",
                                          },
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "price",
                                            "show-overflow-tooltip": "",
                                            label: "代理价格",
                                          },
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "remarks",
                                            "show-overflow-tooltip": "",
                                            label: "备注信息",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-tab-pane",
                                  { attrs: { label: "火车票" } },
                                  [
                                    _c(
                                      "el-table",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          size: "small",
                                          data: row.testDataChild21DTOList,
                                        },
                                      },
                                      [
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "startArea.name",
                                            label: "出发地",
                                          },
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "endArea.name",
                                            label: "目的地",
                                          },
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "starttime",
                                            "show-overflow-tooltip": "",
                                            label: "出发时间",
                                          },
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "endtime",
                                            "show-overflow-tooltip": "",
                                            label: "到达时间",
                                          },
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "price",
                                            "show-overflow-tooltip": "",
                                            label: "代理价格",
                                          },
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "t1File",
                                            "show-overflow-tooltip": "",
                                            sortable: "custom",
                                            label: "文件",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (ref) {
                                                  var row = ref.row
                                                  return [
                                                    row.t1File
                                                      ? _vm._l(
                                                          row.t1File.split(","),
                                                          function (
                                                            item,
                                                            index
                                                          ) {
                                                            return _c(
                                                              "el-link",
                                                              {
                                                                key: index,
                                                                staticClass:
                                                                  "m-r-10",
                                                                attrs: {
                                                                  type: "primary",
                                                                  href: item,
                                                                  target:
                                                                    "_blank",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      decodeURIComponent(
                                                                        item.substring(
                                                                          item.lastIndexOf(
                                                                            "&name="
                                                                          ) + 6
                                                                        )
                                                                      )
                                                                    )
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        )
                                                      : _vm._e(),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "remarks",
                                            "show-overflow-tooltip": "",
                                            label: "备注信息",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-tab-pane",
                                  { attrs: { label: "飞机票" } },
                                  [
                                    _c(
                                      "el-table",
                                      {
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          size: "small",
                                          data: row.testDataChild22DTOList,
                                        },
                                      },
                                      [
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "startArea.name",
                                            label: "出发地",
                                          },
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "endArea.name",
                                            label: "目的地",
                                          },
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "startTime",
                                            "show-overflow-tooltip": "",
                                            label: "出发时间",
                                          },
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "endTime",
                                            "show-overflow-tooltip": "",
                                            label: "到达时间",
                                          },
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "price",
                                            "show-overflow-tooltip": "",
                                            label: "代理价格",
                                          },
                                        }),
                                        _c("el-table-column", {
                                          attrs: {
                                            prop: "remarks",
                                            "show-overflow-tooltip": "",
                                            label: "备注信息",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-column", {
                    attrs: { field: "tuser.name", sortable: "", title: "用户" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm.hasPermission(
                              "test:onetomany:testDataMainForm:edit"
                            )
                              ? _c(
                                  "el-link",
                                  {
                                    attrs: {
                                      type: "primary",
                                      underline: false,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.edit(scope.row.id)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.tuser && scope.row.tuser.name
                                      )
                                    ),
                                  ]
                                )
                              : _vm.hasPermission(
                                  "test:onetomany:testDataMainForm:view"
                                )
                              ? _c(
                                  "el-link",
                                  {
                                    attrs: {
                                      type: "primary",
                                      underline: false,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.view(scope.row.id)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.tuser && scope.row.tuser.name
                                      )
                                    ),
                                  ]
                                )
                              : _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      scope.row.tuser && scope.row.tuser.name
                                    )
                                  ),
                                ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "office.name",
                      sortable: "",
                      title: "所属部门",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  scope.row.office && scope.row.office.name
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-column", {
                    attrs: {
                      field: "area.name",
                      sortable: "",
                      title: "所属区域",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(scope.row.area && scope.row.area.name) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-column", {
                    attrs: { field: "name", sortable: "", title: "名称" },
                  }),
                  _c("vxe-column", {
                    attrs: { field: "sex", sortable: "", title: "性别" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$dictUtils.getDictLabel(
                                    "sex",
                                    scope.row.sex,
                                    "-"
                                  )
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-column", {
                    attrs: { field: "file", sortable: "", title: "身份证照片" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            row.file
                              ? _vm._l(
                                  row.file.split(","),
                                  function (src, index) {
                                    return _c("el-image", {
                                      key: index,
                                      staticStyle: {
                                        height: "50px",
                                        width: "50px",
                                        "margin-right": "10px",
                                      },
                                      attrs: {
                                        src: src,
                                        "preview-src-list": row.file.split(","),
                                      },
                                    })
                                  }
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("vxe-column", {
                    attrs: { field: "inDate", sortable: "", title: "加入日期" },
                  }),
                  _c("vxe-column", {
                    attrs: {
                      fixed: "right",
                      align: "center",
                      width: "200",
                      title: "操作",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm.hasPermission(
                              "test:onetomany:testDataMainForm:view"
                            )
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "text",
                                      icon: "el-icon-view",
                                      size: "small",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.view(scope.row.id)
                                      },
                                    },
                                  },
                                  [_vm._v("查看")]
                                )
                              : _vm._e(),
                            _vm.hasPermission(
                              "test:onetomany:testDataMainForm:edit"
                            )
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "text",
                                      icon: "el-icon-edit",
                                      size: "small",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.edit(scope.row.id)
                                      },
                                    },
                                  },
                                  [_vm._v("修改")]
                                )
                              : _vm._e(),
                            _vm.hasPermission(
                              "test:onetomany:testDataMainForm:del"
                            )
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "text",
                                      icon: "el-icon-delete",
                                      size: "small",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.del(scope.row.id)
                                      },
                                    },
                                  },
                                  [_vm._v("删除")]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c("vxe-pager", {
                attrs: {
                  background: "",
                  size: "small",
                  "current-page": _vm.tablePage.currentPage,
                  "page-size": _vm.tablePage.pageSize,
                  total: _vm.tablePage.total,
                  "page-sizes": [
                    10,
                    20,
                    100,
                    1000,
                    { label: "全量数据", value: 1000000 },
                  ],
                  layouts: [
                    "PrevPage",
                    "JumpNumber",
                    "NextPage",
                    "FullJump",
                    "Sizes",
                    "Total",
                  ],
                },
                on: { "page-change": _vm.currentChangeHandle },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("TestDataMainFormForm", {
        ref: "testDataMainFormForm",
        on: { refreshDataList: _vm.refreshList },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }